export const gamelist = {
  name: 'gamelist',
  path: '/gamelist',
  component: () => import('@/views/member/gamelist'),
  redirect: {
    name: 'listcasino'
  },
  meta: {
    layout: 'default',
    text: '게임리스트',
    gnb: false,
    guestOnly: false
  },
  children: [
    {
      name: 'listcasino',
      path: '/gamelist/casino',
      component: () => import('@/views/member/gamelist/casino'),
      meta: {
        layout: 'default',
        text: '라이브카지노'
      }
    },
    {
      name: 'listhotel',
      path: '/gamelist/casinohotel',
      component: () => import('@/views/member/gamelist/hotel'),
      meta: {
        layout: 'default',
        text: '호텔카지노'
      }
    },
    {
      name: 'listslot',
      path: '/gamelist/slot',
      component: () => import('@/views/member/gamelist/slot'),
      meta: {
        layout: 'default',
        text: '슬롯게임'
      }
    },
    {
      name: 'listmini',
      path: '/gamelist/mini',
      component: () => import('@/views/member/gamelist/minigame'),
      meta: {
        layout: 'default',
        text: '슬롯게임'
      }
    },
    {
      name: 'listsports',
      path: '/gamelist/sports',
      component: () => import('@/views/member/gamelist/sports'),
      meta: {
        layout: 'default',
        text: '슬롯게임'
      }
    },
    {
      name: 'listlivesports',
      path: '/gamelist/livesports',
      component: () => import('@/views/member/gamelist/livesports'),
      meta: {
        layout: 'default',
        text: '실시간스포츠'
      }
    }
  ]
}
